import { useState } from "react";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { partnerLogin } from "../../api/partnerAuthApi";
import { usePartnerAuth } from "../../auth/PartnerAuthProvider";
import { usePartnerPortalBase } from "../../components/partner/PartnerPortalBaseProvider";
import { CASAMAPA_CLIENT_VIEW_SLUG } from "../../constants/casamapaPartnerPortalConfig";
import { resolveSafeReturnTo } from "../../utils/automap/legalDocumentRender";
import { isCasaMapaPartnerAccountIntent } from "../../utils/casamapaPartnerPortalPaths";
import { useLocale } from "../../intl";
import CasaMapaPartnerAuthPage from "./CasaMapaPartnerAuthPage";

const PartnerLoginPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isAuthenticated, refresh } = usePartnerAuth();
  const { clientViewSlug, dashboardPath, portalLabel, portalSubtitle } = usePartnerPortalBase();
  const { t } = useLocale();
  const intent = searchParams.get("intent");
  const returnTo = resolveSafeReturnTo(searchParams.get("returnTo"), dashboardPath);
  const isPartnerIntent = isCasaMapaPartnerAccountIntent(intent);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (clientViewSlug === CASAMAPA_CLIENT_VIEW_SLUG) {
    return <CasaMapaPartnerAuthPage />;
  }

  if (isAuthenticated) {
    return <Navigate to={returnTo} replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setSubmitting(true);
    try {
      await partnerLogin(email, password);
      await refresh();
      navigate(returnTo);
    } catch (error) {
      setErrorMessage(error.message || "Login failed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="midpoint-app auth-page account-area-app">
      <section className="panel-card auth-card">
        <p className="eyebrow">{portalLabel}</p>
        <h1>{t("realEstate.casaMapa.admin.partnerLogin.title")}</h1>
        <p className="muted">
          {isPartnerIntent
            ? t(`realEstate.casaMapa.admin.partnerLogin.subtitle.${intent}`)
            : portalSubtitle}
        </p>
        <form onSubmit={handleSubmit}>
          <label className="admin-users-field">
            <span>Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="username"
            />
          </label>
          <label className="admin-users-field">
            <span>Password</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </label>
          {errorMessage ? <p className="admin-data-health-error">{errorMessage}</p> : null}
          <button type="submit" className="midpoint-share-button" disabled={submitting}>
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="muted">
          <Link to="/">Back to map</Link>
        </p>
      </section>
    </div>
  );
};

export default PartnerLoginPage;
